export function NonMacPreview() {
  return (
    <div className='flex flex-col items-center gap-4 text-center'>
      <h2 className='text-2xl font-semibold text-[var(--color-text-primary)]'>
        Available for macOS
      </h2>
      <p className='max-w-md text-[var(--color-text-secondary)]'>
        Ahoy Desktop is currently for macOS only. We do not have a Linux release
        planned.
      </p>
    </div>
  );
}
